var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductFilter',{attrs:{"isOnProductDetailPage":_vm.isOnProductDetailPage,"placeholderText":_vm.placeholderText,"totalFiltersActive":_vm.totalFiltersActive,"filterType":"option","title":"Options","tooltipText":"For example, size or color."}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327a9b8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/ProductFilterOptions.vue
// module id = mpqR
// module chunks = 1